var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 62,
      height: 62
    },
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0334,
    cy: 30.6067,
    r: 30.6067,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1223 26.6523H18.8555V43.4479H24.1223V26.6523Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3694 26.288C38.1752 26.2637 37.9689 26.2515 37.7626 26.2394C34.8136 26.1181 33.1511 27.8656 32.5686 28.618C32.4108 28.8243 32.338 28.9456 32.338 28.9456V26.7006H27.3018V43.4961H32.338H32.5686C32.5686 41.785 32.5686 40.0861 32.5686 38.3749C32.5686 37.4526 32.5686 36.5303 32.5686 35.608C32.5686 34.4673 32.4836 33.2537 33.054 32.2101C33.5394 31.3363 34.4132 30.8995 35.3962 30.8995C38.3087 30.8995 38.3694 33.5329 38.3694 33.7756C38.3694 33.7877 38.3694 33.7998 38.3694 33.7998V43.5689H43.6362V32.6106C43.6362 28.8607 41.7309 26.652 38.3694 26.288Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4888 24.4801C23.1778 24.4801 24.547 23.1109 24.547 21.4219C24.547 19.733 23.1778 18.3638 21.4888 18.3638C19.7998 18.3638 18.4307 19.733 18.4307 21.4219C18.4307 23.1109 19.7998 24.4801 21.4888 24.4801Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0c17dbf86b66c28ed06d19070655eff7.svg";
export { ForwardRef as ReactComponent };